// eslint-disable-next-line import/prefer-default-export
export var TimeFrames;
(function (TimeFrames) {
    TimeFrames["RAW"] = "RAW";
    TimeFrames["YEAR"] = "YEAR";
    TimeFrames["QUARTER"] = "QUARTER";
    TimeFrames["MONTH"] = "MONTH";
    TimeFrames["WEEK"] = "WEEK";
    TimeFrames["DAY"] = "DAY";
    TimeFrames["HOUR"] = "HOUR";
    TimeFrames["MINUTE"] = "MINUTE";
    TimeFrames["SECOND"] = "SECOND";
    TimeFrames["MILLISECOND"] = "MILLISECOND";
    TimeFrames["DAY_OF_WEEK_INDEX"] = "DAY_OF_WEEK_INDEX";
    TimeFrames["DAY_OF_MONTH_NUM"] = "DAY_OF_MONTH_NUM";
    TimeFrames["DAY_OF_YEAR_NUM"] = "DAY_OF_YEAR_NUM";
    TimeFrames["WEEK_NUM"] = "WEEK_NUM";
    TimeFrames["MONTH_NUM"] = "MONTH_NUM";
    TimeFrames["QUARTER_NUM"] = "QUARTER_NUM";
    TimeFrames["YEAR_NUM"] = "YEAR_NUM";
    TimeFrames["DAY_OF_WEEK_NAME"] = "DAY_OF_WEEK_NAME";
    TimeFrames["MONTH_NAME"] = "MONTH_NAME";
    TimeFrames["QUARTER_NAME"] = "QUARTER_NAME";
    TimeFrames["HOUR_OF_DAY_NUM"] = "HOUR_OF_DAY_NUM";
    TimeFrames["MINUTE_OF_HOUR_NUM"] = "MINUTE_OF_HOUR_NUM";
})(TimeFrames || (TimeFrames = {}));
export var DateGranularity;
(function (DateGranularity) {
    DateGranularity["DAY"] = "Day";
    DateGranularity["WEEK"] = "Week";
    DateGranularity["MONTH"] = "Month";
    DateGranularity["QUARTER"] = "Quarter";
    DateGranularity["YEAR"] = "Year";
})(DateGranularity || (DateGranularity = {}));
export const dateGranularityToTimeFrameMap = {
    [DateGranularity.DAY]: TimeFrames.DAY,
    [DateGranularity.WEEK]: TimeFrames.WEEK,
    [DateGranularity.MONTH]: TimeFrames.MONTH,
    [DateGranularity.QUARTER]: TimeFrames.QUARTER,
    [DateGranularity.YEAR]: TimeFrames.YEAR,
};
//# sourceMappingURL=timeFrames.js.map